import Base from "./Base";

class Config extends Base {
    static getConfig() {
        return this.sendRequest("/home/get-config", "GET");
    }
}

export default Config;